import { Controller } from "stimulus";
import loader from "../assets/loader";
import GoogleRecaptcha from '../assets/google-recaptcha';
import {objectToFormData} from "../assets/forms";
import {fetchText} from "../assets/request";

export default class extends Controller {

    connect() {
        this.onSubmit = this._onSubmit.bind(this);
        this.element.addEventListener("submit", this.onSubmit);
        const captcha_element = this.element.querySelector(".g-recaptcha");
        if (captcha_element) {
            GoogleRecaptcha
                .load()
                .then(() => window.grecaptcha.render(captcha_element, {
                    "callback": (response) => this._grecaptcha_response = response,
                    "expired-callback": () => this._grecaptcha_response = null,
                    "error-callback": () => this._grecaptcha_response = null
                }))
        }
        // required-Felder die leer sind nicht sofort als fehlerhaft markieren
        const pristine_elements = Array.from(this.element.querySelectorAll('input[value=""]:required, select:required'));
        pristine_elements.forEach((element) => {
            if (element.nodeName == "SELECT" && element.value) {
                // Element hat Wert gesetzt, nicht per CSS-Selector ermittelbar
                return;
            }
            element.classList.add("pristine");
            // nach erstem blur wieder entfernen
            element.addEventListener("blur", () => element.classList.remove("pristine"), {
                once: true
            });
        });
    }

    _onSubmit(event) {
        event.preventDefault();
        loader.show();
        const data = {};
        const url = this.element.action;
        const method = (this.element.method || "POST").toUpperCase();
        Array.from(this.element.elements).forEach((element) => {
            if (element.type == "checkbox") {
                if (element.checked) {
                    data[element.name] = element.value;
                }
            } else {
                data[element.name] = element.value;
            }
        });
        // Google Captcha v2 Ergebnis hinzufügen wenn vorhanden
        if (window.grecaptcha && this._grecaptcha_response) {
            data['g-recaptcha-response'] = this._grecaptcha_response;
        }

        this._dispatchEvent("submit", data);
        fetchText(url, {
          method,
          body: objectToFormData(data)
        })
            .then((response) => this._dispatchEvent("success", response))
            .catch((error) => this._dispatchEvent("error", error))
            .then(() => loader.hide()); // finally
    }

    _dispatchEvent(type, data) {
        const event = new CustomEvent("ajax-form:" + type, {
            detail: data,
            bubbles: true
        });
        this.element.dispatchEvent(event);
    }

}
